//  ----------      START   IMPORT  BLOCK       ----------
import { Row, Col, ListGroup, Card } from "react-bootstrap";
import { FaClock } from "react-icons/fa";
//  Context
import { useLanguage } from "../../../../../API/Context/LanguageContext";
//  Config
import { VocabProToPatient as Vocab } from "../../../../../ConfigFiles/multilingual/VocabProToPatient";
//  ----------      END   IMPORT  BLOCK       ----------

const StepWelcome = () => {
    //  Consume context
    const { lan } = useLanguage();

    // Pure array of strings for logic-first simplicity
    const requirements = [
        Vocab.physique[lan],
        Vocab.substance_use[lan],
        Vocab.habits[lan],
    ];

    return (
        <div className="animate-in text-center py-2">
            <div className="mb-4">
                <h3 className="fw-bold text-primary mb-3">
                    {Vocab.welcome_title[lan]}
                </h3>
                <p className="text-muted lead px-md-5">
                    {Vocab.welcome_intro[lan]}
                </p>
            </div>

            <Row className="justify-content-center mb-4">
                <Col md={7}>
                    <Card className="border-0 bg-light rounded-4 p-4 shadow-sm">
                        {/* Time Estimate */}
                        <div className="d-flex align-items-center justify-content-center mb-3">
                            <FaClock className="me-2 text-warning" />
                            <span className="fw-bold me-2">{Vocab.time_label[lan]}</span>
                            <span className="text-secondary">{Vocab.time_value[lan]}</span>
                        </div>
                        
                        <hr className="my-3 opacity-25" />

                        {/* Simplified List */}
                        <h6 className="fw-bold mb-3 text-dark small letter-spacing-1">
                            {Vocab.prep_title[lan]}
                        </h6>
                        <ListGroup variant="flush" className="bg-transparent text-start">
                            {requirements.map((item, i) => (
                                <ListGroup.Item 
                                    key={i} 
                                    className="bg-transparent border-0 py-1 ps-0 d-flex align-items-center"
                                >
                                    <span className="text-primary me-2">•</span>
                                    <span className="text-secondary">{item}</span>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Card>
                </Col>
            </Row>
            {/*
            <p className="small text-muted fst-italic">
                {Vocab.resume[lan]}
            </p>
            */}
        </div>
    );
};

export default StepWelcome;